<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <rect
        width="11.1742"
        height="1.75562"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 20.0049 2.89227)"
        fill="currentColor"
      />
      <path
        d="M15.3994 2.33894C14.8761 2.30542 14.4443 2.73924 14.4778 3.26251C14.5057 3.69901 14.8536 4.04682 15.2901 4.07478L21.5268 4.47429C21.5268 4.47429 21.4585 3.40769 21.4147 2.72426C19.4964 2.60138 16.8233 2.43015 15.3994 2.33894Z"
        fill="currentColor"
      />
      <path
        d="M20.0641 8.84885C20.0921 9.28535 20.4399 9.63316 20.8764 9.66112C21.3997 9.69464 21.8335 9.26278 21.8 8.73952C21.7088 7.3156 21.5376 4.64257 21.4147 2.72426C20.7312 2.68046 19.6646 2.61211 19.6646 2.61211L20.0641 8.84885Z"
        fill="currentColor"
      />
      <path
        d="M3 4.68L3 20.32C3 20.6961 3.30387 21 3.68 21L19.32 21C19.6961 21 20 20.6961 20 20.32L20 12.67C20 12.5765 19.9235 12.5 19.83 12.5L18.64 12.5C18.5465 12.5 18.47 12.5765 18.47 12.67L18.47 19.47L4.53 19.47L4.53 5.53L11.33 5.53C11.4235 5.53 11.5 5.4535 11.5 5.36L11.5 4.17C11.5 4.0765 11.4235 4 11.33 4L3.68 4C3.30387 4 3 4.30387 3 4.68Z"
        fill="currentColor"
      />
    </g>
    <!--    <defs>-->
    <!--      <clipPath id="clip0">-->
    <!--        <rect width="24" height="24" fill="white" transform="translate(0 24) rotate(-90)"/>-->
    <!--      </clipPath>-->
    <!--    </defs>-->
  </svg>
</template>

<script>
export default { name: 'ExternalLink' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
